<template>
  <v-navigation-drawer
      v-model="drawer"
      app
      fixed
      clipped
      :width="$vuetify.breakpoint.mobile ? '100%' : 300"
      :mini-variant.sync="mini"
      mobile-breakpoint="0"
      mini-variant-width="75"
      style="min-width: 75px;"
    >
    <v-list-item class="px-2">
      <v-btn block text @click.stop="mini = !mini" class="d-flex justify-end" >
        <v-icon v-if="mini">mdi-chevron-right</v-icon>
        <v-icon v-else>mdi-chevron-left</v-icon>
      </v-btn>
    </v-list-item>
    <v-divider v-if="!mini" />
    <user-select v-if="!mini"/>
    <v-divider></v-divider>
    <v-list dense>
      <v-list-item v-for="item in items" :key="item.text" @click="navigate()" :to="{ path: item.route }" v-show="item.displayed" :class="item.class">
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import UserSelect from '@/components/settings/users_select'
import { mapGetters } from 'vuex'

export default {
  name: 'settings-drawer',
  data () {
    return {
      dialog: false,
      drawer: null,
      mini: this.$vuetify.breakpoint.mobile
    }
  },
  components: {
    UserSelect
  },
  computed: {
    ...mapGetters({
      emergencyDisabled: 'settings/eCIDDisabledGlobally',
      userID: 'settings/userID',
      ownerID: 'settings/ownerID'
    }),
    impersonating () {
      return this.userID !== this.ownerID
    },
    items () {
      return [
        { text: this.$t('settings.drawer.phoneStatus'), icon: 'mdi-phone-ring', route: '/settings/phone_status', displayed: true, class: 'drawer-btn-phoneStatus' },
        { text: this.$t('settings.drawer.devices'), icon: 'mdi-devices', route: '/settings/devices', displayed: true, class: 'drawer-btn-devices' },
        { text: this.$t('settings.drawer.account'), icon: 'mdi-account-cog', route: '/settings/account', displayed: true, class: 'drawer-btn-account' },
        { text: this.$t('settings.drawer.softphone'), icon: 'mdi-phone-voip', route: '/settings/softphone', displayed: !this.impersonating, class: 'drawer-btn-softphone' },
        { text: this.$t('settings.drawer.emergency'), icon: 'mdi-car-emergency', route: '/settings/emergency', displayed: !this.emergencyDisabled, class: 'drawer-btn-emergency' },
        { text: this.$t('settings.drawer.notifications'), icon: 'mdi-bell-cog', route: '/settings/notifications', displayed: !this.impersonating, class: 'drawer-btn-notifications' },
        { text: this.$t('settings.drawer.clickToDial'), icon: 'mdi-mouse-right-click', route: '/settings/click_to_dial', displayed: true, class: 'drawer-btn-clickToDial' },
        { text: this.$t('settings.drawer.callScreenPop'), icon: 'mdi-window-shutter-auto', route: '/settings/call_screen_pop', displayed: true, class: 'drawer-btn-callScreenPop' },
        { text: this.$t('settings.drawer.stunServers'), icon: 'mdi-web', route: '/settings/stun_servers', displayed: true, class: 'drawer-btn-stunServers' }
      ]
    }
  },
  methods: {
    navigate () {
      if (this.$vuetify.breakpoint.mobile) {
        this.mini = true
      }
    }
  }
}
</script>

<style>

</style>
